import { Dispatch, SetStateAction } from "react";
import ToggleButtonGroup from "../../../Atoms/ToggleButtonGroup/ToggleButtonGroup";
import { TimeRange, allTimeRanges } from "../../SearchBar/SearchProvider";
import { timeRangeToIcon } from "./DateRangeSearch";

type TimeRangePickerProps = {
  timeRanges: TimeRange[];
  setTimeRanges: Dispatch<SetStateAction<TimeRange[]>>;
};

export default function TimeRangePicker({
  timeRanges,
  setTimeRanges,
}: TimeRangePickerProps) {
  const options = allTimeRanges.map((timeRange) => {
    const isSelected = timeRanges.includes(timeRange);
    const iconKey = `${timeRange}${isSelected ? "Included" : ""}`;
    const Icon = timeRangeToIcon[iconKey];
    return {
      id: timeRange,
      endAdornment: <Icon />,
    };
  });
  return (
    <ToggleButtonGroup
      options={options}
      selected={timeRanges}
      setSelected={setTimeRanges}
      minOneSelected
      style={{
        border: "1px solid rgb(195, 195, 195)",
        padding: "4px",
        borderRadius: "22px",
      }}
    />
  );
}
